import React from 'react';

import { BottomBevelCut, SingleBevelCut } from '@paragon/contract-library';
import { AngleField } from '@paragon/material';

interface Props<T extends SingleBevelCut | BottomBevelCut> {
  bevelCut: T;
  disabled: boolean;
  onEditBevelCut: (newBevelCut: T) => void;
}

const SingleOrBottomBevelCutProperties = <T extends SingleBevelCut | BottomBevelCut>(props: Props<T>) => {
  const { bevelCut, disabled, onEditBevelCut } = props;

  return (
    <AngleField
      label="Angle"
      value={bevelCut.angle}
      min={1}
      max={89}
      onSubmit={(angle) => onEditBevelCut({ ...bevelCut, angle })}
      disabled={disabled}
    />
  );
};

export const SingleBevelCutProperties = SingleOrBottomBevelCutProperties<SingleBevelCut>;
export const NonNullBottomBevelCutProperties = SingleOrBottomBevelCutProperties<BottomBevelCut>;
